/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData =
  {
    message: string;
  };

/**
 * Rate limited
 */
export class DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err:
      DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData =
  {
    message: string;
  };

/**
 * Conflict
 */
export class DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err:
      DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData =
  {
    message: string;
  };

/**
 * Not found
 */
export class DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err:
      DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData =
  {
    message: string;
  };

/**
 * Forbidden
 */
export class DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err: DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountApiKeyAuthServiceAccountsResponseBodyData;

  constructor(
    err: DeleteServiceAccountApiKeyAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type DeleteServiceAccountApiKeyResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class DeleteServiceAccountApiKeyResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: DeleteServiceAccountApiKeyResponseBodyData;

  constructor(
    err: DeleteServiceAccountApiKeyResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "DeleteServiceAccountApiKeyResponseBody";
  }
}

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(
    DeleteServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody
  > = z.instanceof(
    DeleteServiceAccountApiKeyAuthServiceAccountsResponseResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody
  > = z.instanceof(DeleteServiceAccountApiKeyAuthServiceAccountsResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const DeleteServiceAccountApiKeyResponseBody$inboundSchema: z.ZodType<
  DeleteServiceAccountApiKeyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new DeleteServiceAccountApiKeyResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type DeleteServiceAccountApiKeyResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const DeleteServiceAccountApiKeyResponseBody$outboundSchema: z.ZodType<
  DeleteServiceAccountApiKeyResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteServiceAccountApiKeyResponseBody
> = z.instanceof(DeleteServiceAccountApiKeyResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
